module.exports = __webpack_public_path__ + "static/05-838f262d90c6327ba64903b53c847fcc.jpg";